import { useAuth } from '@/core/contexts/AuthContext';
import { useIsAdhaJourney } from '@/core/hooks';
import { getUnauthenticatedLandingPath } from '@/core/constants/appConfig';
import {
  buildWelcomeDeepLinkLoginHref,
  readExternalAdhaDeepLink,
} from '@/modules/properties-web/utils/adhaDeepLinkRedirect';
import { Redirect, Stack, type Href } from 'expo-router';

/**
 * ADHA catalogue routes (`/properties-web/*`).
 * - Require auth
 * - Guests opening an external link (`?redirectionFrom=`) go to Emirates ID login
 *   and return to that link after ADHA login
 * - ADHA journey only (email users redirected to normal home)
 * - Listing index redirects to `/` (home hosts the ADHA listing)
 */
export default function PropertiesWebLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const isAdhaJourney = useIsAdhaJourney();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    const externalDeepLink = readExternalAdhaDeepLink();
    if (externalDeepLink) {
      return <Redirect href={buildWelcomeDeepLinkLoginHref(externalDeepLink) as Href} />;
    }
    return <Redirect href={getUnauthenticatedLandingPath() as Href} />;
  }

  if (!isAdhaJourney) {
    return <Redirect href="/(auth)/(home)" />;
  }

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="details" />
    </Stack>
  );
}
